module.exports = __webpack_public_path__ + "mw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/mw.svg
// module id = 713
// module chunks = 0